import { itemAPI2 } from 'estimate_list/libs/api2'
export const getCookie = function (name) {
    let cookieValue = null
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.substring(0, name.length + 1) === name + '=') {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                break
            }
        }
    }
    return cookieValue
}

export const setCookie = function (name, value, expires, path, domain, secure) {
    // options=options||{};
    if (value === null) {
        value = ''
        expires = -1
    }
    if (expires && (typeof expires === 'number' || expires.toUTCString)) {
        let date
        if (typeof expires === 'number') {
            date = new Date()
            date.setTime(date.getTime() + expires * 1000)
        } else {
            date = expires
        }
        expires = ';expires=' + date.toUTCString()
    }
    path = path ? ';path=' + path : ''
    domain = domain ? ';domain=' + domain : ''
    secure = secure ? ';secure' : ''
    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('')
}

export const setShareEstimateItems = async (estimate_idx) => {
    // const cookie = getCookie('item_est')
    // if(cookie){
    //     const cookieArr = cookie.toString().split(',')
    //     for (let i in cookieArr) {
    //         setCookie('cnt_' + cookieArr[i].toString(), '', 9 * 24 * 60 * 60, '/', '.pping.' + process.env.REACT_APP_TLD)
    //     }
    //     setCookie('item_est', '', 9 * 24 * 60 * 60, '/', '.pping.' + process.env.REACT_APP_TLD)
    // }
    await itemAPI2.getShareItemEstimate(estimate_idx).then((rst) => {
        // const items = rst.data.items
        // if(items){
        //     const newArr = items.map(v => {
        //         setCookie('cnt_' + v.itemId.toString(), v.count, 9 * 24 * 60 * 60, '/', '.pping.' + process.env.REACT_APP_TLD)
        //         return v.itemId
        //     });
        //     setCookie('item_est', (newArr.join(',')).toString(), 9 * 24 * 60 * 60, '/', '.pping.' + process.env.REACT_APP_TLD)
        // }
        /**
         * API호출하면 백에서 쿠키에 담아서 넘겨주기때문에 '/'로 redirect만 시키면됨
         * */
        const mallName = rst?.data?.mallWebUser
        if(!mallName || mallName === 'happystdpc1') {
            window.location.replace('/')
            return
        }
        if(mallName) {
            window.location.replace(`${process.env.REACT_APP_MINISHOP_URL}/${mallName}`)
        }
    })
}



// WEBPACK FOOTER //
// ./src/estimate_list/libs/cookie.js